/**
 * App header Object
 *
 * @type object
 */
App.header = {

    /**
     * Constructor Function
     *
     * Boot function
     */
    init: function() {

    },


    /**
     * Get header height
     *
     * @returns {*|jQuery}
     */
    getHeight: function() {
        return $('header nav').outerHeight();
    },


    /**
     * Handle header height
     */
    handleHeight: function() {

    }
};